<template>
  <div>
    <v-row justify="center">
      <v-expansion-panels accordion tile>
        <v-expansion-panel v-for="(factoid, index) in geoFactoids" :key="index">
          <v-expansion-panel-header
            class="text-center"
            v-if="validFactoid(factoid.value)"
            :hide-actions="!validFactoid(factoid.text)"
            :disabled="!validFactoid(factoid.text)"
          >
            <div class="headline">
              {{
                factoid.value
                  | getFormattedNumber(factoid.field, factoid.format)
              }}
              <span class="overline d-block pt-0">{{ factoid.label }}</span>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content
            v-if="validFactoid(factoid.value)"
            class="expansion-panel-content"
          >
            {{ factoid.text }}
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </div>
</template>

<script>
import numeralHelper from '@/helpers/NumeralHelper';
import { mapGetters } from 'vuex';
export default {
  name: 'NavPanelListInfo',
  computed: {
    ...mapGetters({
      geoFactoids: 'mapTemplate/geographyFactoids'
    })
  },
  filters: {
    getFormattedNumber: function (value, field, format) {
      return numeralHelper.getFormattedNumber(value, field, format);
    }
  },
  methods: {
    validFactoid(value) {
      const hyphen = '–';
      return value && value != hyphen;
    }
  }
};
</script>

<style lang="scss" scoped>
.expansion-panel-content {
  font-family: $ne-body-font-family;
}
</style>
